<agpr-take-over-panel
    id="upsellInfo_dialog"
    class="agpr-upsellInfo"
    [header]="header"
    [width]="45"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="cancel()"
>
    <div class="agpr-upsellInfo-content">
        {{subHeader | localize }}

        <div class="agpr-upsellInfo-scrollPanel">
            <agpr-scroll-panel>
                <ul
                    class="agpr-upsellInfo-itemContainer"
                    [attr.aria-label]="'Social.intelligence.themeManagement.agent' | localize"
                >
                    <li *ngFor="let item of infoSectionListItems">
                        <img
                            class="agpr-upsellInfo-logo"
                            [src]="appBaseHref + 'assets/images/' + item.image +'.svg'"
                            alt=""
                        />
                        <p>
                            <span class="agpr-upsellInfo-heading">
                                {{ item.heading }}
                            </span>
                            <span
                                *ngIf="item.description"
                                class="agpr-upsellInfo-description"
                                [innerHTML]="item.description"
                            >
                                {{ item.description }}
                            </span>
                            <span *ngIf="item.descriptionHtml" [innerHTML]="item.descriptionHtml"></span>
                        </p>
                    </li>
                </ul>
            </agpr-scroll-panel>
        </div>
        <p *ngIf="!successMessage" class="agpr-upsellInfo-learnMore">
            <span class="agpr-upsellInfo-learnMore-label"> {{ 'Core.upsellInfoDialog.learnMore' | localize }} </span>
            {{ learnMoreMessage }}
        </p>
        <agpr-message
            *ngIf="successMessage"
            severity="success"
        >
            {{ successMessage | localize }}
        </agpr-message>
    </div>


    <ng-template #takeOverFooterLeft>
        <agpr-button
            label="cancel"
            (click)="closeDialog()"
            [style]="buttonTypesEnum.secondary"
        ></agpr-button>
    </ng-template>

    <ng-template #takeOverFooterRight>
        <agpr-button
            label="Core.upsellInfoDialog.learnMore"
            [style]="buttonTypesEnum.primary"
            (click)="navigateToLearnMore()"
        ></agpr-button>
        <agpr-button
            label="Core.upsellInfoDialog.getInTouch"
            [style]="buttonTypesEnum.primary"
            (click)="submitRequest()"
        ></agpr-button>
    </ng-template>

</agpr-take-over-panel>
